import { render, staticRenderFns } from "./dadosEmpregaticios.vue?vue&type=template&id=4857cff0&scoped=true&"
import script from "./dadosEmpregaticios.vue?vue&type=script&lang=js&"
export * from "./dadosEmpregaticios.vue?vue&type=script&lang=js&"
import style0 from "./dadosEmpregaticios.vue?vue&type=style&index=0&id=4857cff0&lang=scss&scoped=true&"
import style1 from "./dadosEmpregaticios.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4857cff0",
  null
  
)

export default component.exports